import { Logger } from "./logger";

interface ILogClassSettings {
  source?: string;
}

export function LogClass(settings?: ILogClassSettings): ClassDecorator {
  // eslint-disable-next-line @typescript-eslint/ban-types
  return <TFunction extends Function>(target: TFunction): TFunction => {
    let source = target.name;

    if (settings && settings.source) {
      source = settings.source;
    }

    const logger = new Logger(source);
    logger.debug("LogClass");
    Object.defineProperty(target.prototype, "logger", {
      get: () => logger,
      enumerable: true,
      configurable: true
    });
    return target;
  };
}
